import { createCoverageTypes } from '../../../common/coverage/types';

export const NAMESPACE = 'analytics-rdc-os-coverage';

export const {
  CLEANUP,
  INITIALIZED,
  CHANGE_SORTING,
  GET_COVERAGE,
  GET_COVERAGE_CSV,
} = createCoverageTypes(NAMESPACE);
